import type { SVGProps } from 'react';

export const LogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.06265 15.081C4.96846 18.6277 8.2043 21.2608 12.0492 21.2608C15.894 21.2608 19.1299 18.6296 20.0357 15.081H24.0983C23.1289 20.829 18.0969 25.2238 12.0492 25.2238C6.00146 25.2238 0.96941 20.829 0 15.081H4.06265Z"
      className="fill-ds-icon-2"
    />
    <path
      d="M12.053 0.903687C18.1007 0.903691 23.1327 5.29854 24.1021 11.0465H20.0376C19.1318 7.49983 15.8959 4.86677 12.0511 4.86677C8.20622 4.86677 4.97037 7.4979 4.06456 11.0465H0C0.969411 5.29854 6.00532 0.903687 12.053 0.903687Z"
      className="fill-ds-icon-2"
    />
  </svg>
);
